// extracted by mini-css-extract-plugin
export var label = "_g4-2";
export var slideContainer = "_g4-0";
export var slider = "_g4-1";